import React, { useState, useEffect } from 'react';
import Accordion from '../../../Design/Accordion/Accordion';
import { items } from '../../../Design/Accordion/AccordionData';
import { useAuth } from '../../../../context/AuthContext';
import { addSponsor } from '../../../../utils/sponsor.controller';

function DealCreate() {
  const { user, loading } = useAuth();
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // Initialize form data with empty values
  const [formData, setFormData] = useState({
    companyName: '',
    companyWebsite: '',
    companyDescription: '',
    companyAddress: '',
    user_id: '', 
  });

  // Update user_id whenever the user object changes
  useEffect(() => {
    if (user?.id) {
      setFormData(prev => ({
        ...prev,
        user_id: user.user_id,
      }));
      console.log('User ID set from context:', user.user_id);
    }
  }, [user]);

  if (loading) return <div>Loading user data...</div>;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrorMessage('');
    
    try {
      // Make sure user_id is included in the form data
      if (!formData.user_id && user?.user_id) {
        formData.user_id = user.user_id; // Ensure user_id is set
      }
      
      console.log('Submitting form data:', formData);
      
      // Call the sponsor controller with the complete form data
      const result = await addSponsor({ 
        formData: formData, 
        user_id: formData.user_id
      });
      
      console.log('✅ Data saved:', result);
      setSuccessMessage('Company information saved successfully!');
      
      // Optionally reset some fields after successful submission
      setFormData({
        ...formData,
        // Preserve user_id but reset other fields if needed
        // companyName: '',
        // companyWebsite: '',
        // companyDescription: '',
        // companyAddress: '',
      });
    } catch (error) {
      console.error('Error saving data:', error);
      setErrorMessage(error.message || 'Failed to save company information. Please try again.');
    }
  };

  return (
    <div className="deal-create-container">
      {successMessage && (
        <div className="success-message" style={{ color: 'green', padding: '10px', marginBottom: '15px', backgroundColor: '#f0fff0', border: '1px solid green', borderRadius: '4px' }}>
          {successMessage}
        </div>
      )}
      
      {errorMessage && (
        <div className="error-message" style={{ color: 'red', padding: '10px', marginBottom: '15px', backgroundColor: '#fff0f0', border: '1px solid red', borderRadius: '4px' }}>
          {errorMessage}
        </div>
      )}
      
      <h2>Create Your Deal</h2>
      <p>Fill in the details to create your sponsorship deal.</p>
      
      <Accordion
        items={items}
        keepOthersOpen={true}
        formData={formData}
        setFormData={setFormData}
        handleSubmit={handleSubmit}
      />
    </div>
  );
}

export default DealCreate;